<template>
    <div class="regist selectClubs">
        <p class="aCt">
            お気に入り選手は3クラブまで登録できます。<br>
            1クラブあたり3名の選手を登録できます。
        </p>

        <input v-for="league in leagues" :key="league" type="radio" name="league" :id="'league' + league" :value="league" v-model="selectedLeague" class="hiddenTrig">

        <div class="leagueToggle">
            <ul class="selectLeague">
                <li v-for="league in leagues" :key="league" :tabindex="0" @keydown.enter="selectLeague(league)">
                    <label :for="'league' + league" 
                            :class="{ active: selectedLeague === league, [league.toLowerCase()]: true }">{{ league }}</label>
                </li>
            </ul>
            <ul v-for="league in leagues"
                :class="['clubList', 'setting', league.toLowerCase()]">
                <li v-for="club in getSpecifiedClubTeams(league)" :key="club.clubCode">
                    <div class="club-team">
                        <img :src="emblemImagePath(club.emblemImg)"
                                :alt="club.teamName">{{ club.teamName }}
                        <label class="mail-setting" :tabindex="getTabIndex(league)" @keydown.enter="goToPlayerSelection(club.clubCode, $event)">
                            <input 
                                v-model="selectedClubCodes"
                                @click="goToPlayerSelection(club.clubCode, $event)"
                                :value="club.clubCode"
                                type="checkbox">
                            <b>
                                <i class="fas fa-portrait"></i>
                            </b>
                        </label>
                    </div>
                </li>
            </ul>
        </div>

        <div class="btnSpace duo">
            <button @click="back"
                    type="button"
                    class="return">戻る</button>
            <xhr-button :is-xhr="isXhr"
                        @on-click="next"
                        id="club_regist_tap2"
                        button-label="確認"></xhr-button>
        </div>
    </div>
</template>

<script>
import { mixinJleague } from '../../mixin/utility'
import XhrButton from '../XhrButton.vue'


export default {
    name: 'SelectClubForSignup',
    mixins: [mixinJleague],
    components :{
        'xhr-button': XhrButton,
    },
    props: {
        favoritePlayerList: {
            type: Array,
            required: true
        },
        selectedClubCodes: {
            type: Array,
            required: true
        },
        userinfo: {
            type: Object,
            required: true
        },
        step: {
            type: String,
            default: ''
        },
        isXhr: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            leagues: ['J1', 'J2', 'J3'],
            selectedLeague: 'J1'
        }
    },
    mounted() {
        this.setSelectedClubCodes();
    },
    methods: {
        emblemImagePath(file) {
            return 'https://auth2.jleague.jp/emblem/' + file;
        },
        selectLeague(league) {
            this.selectedLeague = league;
        },
        getTabIndex(league) {
            return league === this.selectedLeague ? 0 : -1;
        },
        goToPlayerSelection(clubCode, event) {
            const isAlreadySelected = this.selectedClubCodes.includes(clubCode);
            if (this.selectedClubCodes.length <= 3 || isAlreadySelected) {
                if (!isAlreadySelected && this.selectedClubCodes.length >= 3) {
                    alert('登録できるクラブは3つまでです。');
                    event.preventDefault();
                    return;
                }
                this.$emit('club-selected', clubCode);
            }
        },
        setSelectedClubCodes() {
            if (this.favoritePlayerList.length > 0) {
                this.selectedClubCodes = this.favoritePlayerList.map(club => club.club_cd);
            }
        },
        next: function(){
            this.userinfo["favorite_player_list"] = this.favoritePlayerList;
            this.$emit('next', this.step, );
        },
        back: function(){
            this.$emit('back', this.step);
        },
    }
}
</script>
